import React, { useState, useEffect, useContext } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { SiteContext } from '../context';

const validationSchema = Yup.object().shape({
    identification: Yup.string()
      .required('ID field required')
  });
  
const UploadProfileIdentificationForm = ({ handleSubmit, user, setShowModal }) => {
  const [errorMsg, setErrorMsg] = useState('');
  const {apiUrl, userData} = useContext(SiteContext);


    return (
      <div>
        <div className='container'>

            <h3 className='my-2'>Upload profile identification</h3>

          {errorMsg !== '' ? <span className='p-2 my-2 border border-danger text-danger'>{errorMsg}</span> : null}

          <Formik
                    initialValues={{
                      id: user.id,
                      identification: '',
                      posterrole: userData.role,
                      posterid: userData.id
                    }}
                    validationSchema={validationSchema}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                      handleSubmit(values, { setSubmitting, resetForm, setShowModal });
                    }}
                  >
                    {({
                      handleChange,
                      values,
                      handleSubmit,
                      errors,
                      isValid,
                      isSubmitting,
                      handleBlur,
                      touched,
                      setFieldValue
                    }) => (
                      <form onSubmit={handleSubmit} encype="multipart/form-data">
                        <div className='row'>
                          <div className='col-md-6'>

                        <div className='form-group my-2'>
                          <div>
                            <label htmlFor="identification"> Upload identification</label>
                          </div>
                          <input id="identification" name="identification" type="file" onChange={(event) => {
                                 setFieldValue("identification", event.currentTarget.files[0]);
                            }} />
                        </div>

                          </div>
                          <div className='col-md-6'>
                          <button
                            type='submit'
                            buttonType="outline"
                            onClick={handleSubmit}
                            title="Upload ID"
                            disabled={!isValid || isSubmitting}
                            loading={isSubmitting}
                              className='btn btn-primary'
                          >
                              Submit
                          </button>

                          </div>
                        </div>
                        
                          </form>
                    )}
                  </Formik>

      </div>
    </div>
    )
}

export default UploadProfileIdentificationForm;